var _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 52H67V71H6V52Z",
    fill: "#93989F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 73,
    rx: 5,
    fill: "#93989F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0594 63.8753C60.8995 60.0947 61.3025 56.0389 61.0786 53.2655C60.9603 51.7926 60.0711 50.3802 59.0956 49.2279C53.591 42.7192 42.9401 41.6304 37.2309 41.5488L35.9588 41.4976C35.9539 41.4974 35.9552 41.4975 35.9504 41.4973C35.7938 41.4917 19.6001 40.9291 11.5249 49.0797C10.4566 50.1564 9.66015 51.6444 9.54181 53.1173C9.32112 55.8907 9.72092 59.9465 9.561 63.7271",
    fill: "#737982"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1927 39.547C43.5834 39.547 50.3854 32.7088 50.3854 24.2735C50.3854 15.8382 43.5834 9 35.1927 9C26.802 9 20 15.8382 20 24.2735C20 32.7088 26.802 39.547 35.1927 39.547ZM34.6104 14.5914C31.243 14.7801 29.1566 16.2444 28.3699 18.8804C28.0283 20.0249 29.0232 21.0408 30.2176 21.0408V21.0408C31.3534 21.0408 32.1977 19.9929 33.0078 19.1969C33.4143 18.7975 33.9786 18.5322 34.6828 18.4543C36.2024 18.32 37.6497 18.6559 38.0839 19.5964C38.5542 20.6377 37.5049 21.847 36.9984 22.3508C36.5827 22.7664 36.054 23.1361 35.5247 23.5063C34.856 23.9738 34.1863 24.442 33.742 25.0045C33.3119 25.575 33.0789 26.2424 32.9445 27.0067C32.7617 28.0464 33.6469 28.9346 34.7026 28.9346V28.9346C35.7007 28.9346 36.4324 28.1242 36.6901 27.16C36.7792 26.8269 36.9104 26.5286 37.1069 26.2809C37.622 25.6365 38.2895 25.2107 38.9636 24.7808C39.3787 24.516 39.7963 24.2496 40.1824 23.9296C41.1593 23.157 42.2086 22.2165 42.3533 20.7385C42.9684 16.4053 39.1331 14.3227 34.6104 14.5914ZM36.8213 31.9582C36.8213 33.211 35.7473 34.2266 34.4224 34.2266C33.0976 34.2266 32.0236 33.211 32.0236 31.9582C32.0236 30.7055 33.0976 29.6899 34.4224 29.6899C35.7473 29.6899 36.8213 30.7055 36.8213 31.9582Z",
    fill: "#737982"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefult);
export default __webpack_public_path__ + "static/media/defult.bccbadd7f4874005945e2d47420c287f.svg";
export { ForwardRef as ReactComponent };